import { BoMItemRow } from 'model/Project/BoMItemRow'
import { IssuesFilter } from 'store/Project/ProjectTypes'
import { showPartBasedOnIssues } from './showPartBasedOnIssues'

export function applyIssuesFilter(
  filter: IssuesFilter,
  row: BoMItemRow
): boolean {
  let issuesFilterAppliedShowItem = false

  switch (row.type) {
    case 'Row': {
      issuesFilterAppliedShowItem = showPartBasedOnIssues(row, filter)
    }
  }

  return issuesFilterAppliedShowItem
}
